var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96429 1H12.0357C12.5687 1 13 1.43125 13 1.96429V12.0357C13 12.5687 12.5687 13 12.0357 13H1.96429C1.43125 13 1 12.5687 1 12.0357V1.96429C1 1.43125 1.43125 1 1.96429 1ZM1.96428 12.0357H12.0357V1.96429H1.96428V12.0357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76786 10.0536H9.94643C10.2129 10.0536 10.4286 9.83795 10.4286 9.57143C10.4286 9.30491 10.2129 9.08929 9.94643 9.08929H5.76786C5.50134 9.08929 5.28571 9.30491 5.28571 9.57143C5.28571 9.83795 5.50134 10.0536 5.76786 10.0536Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76786 4.91071H9.94643C10.2129 4.91071 10.4286 4.69509 10.4286 4.42857C10.4286 4.16205 10.2129 3.94643 9.94643 3.94643H5.76786C5.50134 3.94643 5.28571 4.16205 5.28571 4.42857C5.28571 4.69509 5.50134 4.91071 5.76786 4.91071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76786 7.48214H9.94643C10.2129 7.48214 10.4286 7.26652 10.4286 7C10.4286 6.73348 10.2129 6.51786 9.94643 6.51786H5.76786C5.50134 6.51786 5.28571 6.73348 5.28571 7C5.28571 7.26652 5.50134 7.48214 5.76786 7.48214Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57143 9.58929C4.57143 9.86543 4.34757 10.0893 4.07143 10.0893C3.79529 10.0893 3.57143 9.86543 3.57143 9.58929C3.57143 9.31314 3.79529 9.08929 4.07143 9.08929C4.34757 9.08929 4.57143 9.31314 4.57143 9.58929Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57143 4.44643C4.57143 4.72257 4.34757 4.94643 4.07143 4.94643C3.79529 4.94643 3.57143 4.72257 3.57143 4.44643C3.57143 4.17029 3.79529 3.94643 4.07143 3.94643C4.34757 3.94643 4.57143 4.17029 4.57143 4.44643Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57143 7.01786C4.57143 7.294 4.34757 7.51786 4.07143 7.51786C3.79529 7.51786 3.57143 7.294 3.57143 7.01786C3.57143 6.74171 3.79529 6.51786 4.07143 6.51786C4.34757 6.51786 4.57143 6.74171 4.57143 7.01786Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks-icon.4bdf80cc.svg";
export { ForwardRef as ReactComponent };